import { watch, onBeforeMount, onBeforeUnmount, WatchStopHandle } from 'vue-demi';

import { useAuth } from './use-auth';
import { useOnlineStatus } from './use-online-tracker';
import { useWSEventsWorker } from '@/workers/ws-events/composables';
import { VoiceAPI } from '@/api';

/**
 * Token is updated every ~10-60 minutes so we have to propagate changes.
 * TODO: Merge with "useOnlineTracker"?
 */
export const useAuthToken = () => {
  const { getToken } = useAuth();
  const { updateWSToken } = useWSEventsWorker();
  const { isAuthDataReady } = useOnlineStatus();

  const TOKEN_REFRESH_CHECK_MS = 30 * 1000;
  const stop: WatchStopHandle[] = [];

  onBeforeMount(() => {
    /**
     * WS Event Manager and Voice API reconnect automatically and need up-to-date token
     * TODO: Can we rely on token reactivity rather than "setInterval"?
     */
    const timer = window.setInterval(() => {
      updateWSToken(getToken());
      VoiceAPI.updateToken(getToken());
    }, TOKEN_REFRESH_CHECK_MS);

    stop.push(() => window.clearTimeout(timer));

    /* When we recover from network disconnect update token as well */
    stop.push(watch(isAuthDataReady, (current, previous) => {
      if (current && !previous) {
        updateWSToken(getToken());
        VoiceAPI.updateToken(getToken());
      }
    }));
  });

  onBeforeUnmount(() => {
    stop.map(cb => cb());
  });
};
